"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QBOdataVisitor = void 0;
const uniqueId_1 = __importDefault(require("lodash/uniqueId"));
const odata_expression_visitor_1 = require("./odata-expression-visitor");
class QBOdataVisitor extends odata_expression_visitor_1.ODataExpressionVisitor {
    visitLiteralNode(node) {
        let value = node.value;
        if (node.value instanceof Array) {
            value = node.value[0];
        }
        return value;
    }
    visitPropertyNode(node) {
        return node.name;
    }
    visitConditionalNode(node, level) {
        const operator = node.type;
        const leftResult = odata_expression_visitor_1.ODataExpressionVisitor.accept(node.left, this, level);
        const rightResult = odata_expression_visitor_1.ODataExpressionVisitor.accept(node.right, this, level);
        const newNode = {
            id: `r-${uniqueId_1.default()}`,
            field: leftResult,
            operator: operator,
            value: rightResult,
        };
        if (rightResult === null) {
            newNode.operator =
                operator == 'eq' ? 'value does not exist' : 'value exists';
        }
        return newNode;
    }
    visitFunctionCallNode(node) {
        const query = {
            id: `r-${uniqueId_1.default()}`,
            field: null,
            operator: node.func,
            value: null,
        };
        for (let arg of node.args) {
            const result = odata_expression_visitor_1.ODataExpressionVisitor.accept(arg, this);
            if (arg.type === 'literal') {
                query.value = result;
            }
            else {
                query.field = result;
            }
        }
        return query;
    }
    visitBinaryExpressionNode(node, level) {
        const operator = node.type;
        const query = {
            id: `g-${uniqueId_1.default()}`,
            rules: [],
            combinator: operator,
        };
        if (!this.isBinaryOperator(node.left) &&
            this.isBinaryOperator(node.right) &&
            this.binaryOperatorPresedence(node.right) ===
                this.binaryOperatorPresedence(node)) {
            query.rules = [
                odata_expression_visitor_1.ODataExpressionVisitor.accept(node.left, this, level),
                ...odata_expression_visitor_1.ODataExpressionVisitor.accept(node.right, this, level).rules,
            ];
        }
        else {
            query.rules = [
                odata_expression_visitor_1.ODataExpressionVisitor.accept(node.left, this, level),
                odata_expression_visitor_1.ODataExpressionVisitor.accept(node.right, this, level),
            ];
        }
        return query;
    }
}
exports.QBOdataVisitor = QBOdataVisitor;
//# sourceMappingURL=qb-odata-visitor.js.map